import { supabase } from './supabase';

/**
 * Log a modal decision to the modal_decision_log table.
 * This records every user interaction with dashboard modals (budget
 * acknowledgments, report link/dismiss, etc.) for audit and debugging.
 */
export async function logModalDecision(
  projectId: string,
  modalType: 'overspend_budget' | 'report_suggestion' | 'report_link' | 'report_unlink' | 'budget_shift' | 'budget_edit_save',
  action: 'acknowledged' | 'saved_new_budget' | 'dismissed' | 'linked_report' | 'unlinked_report' | 'shifted_budget',
  details?: Record<string, any>,
): Promise<void> {
  console.log(`%c[ModalLog] START logModalDecision`, 'color: #6366f1; font-weight: bold', {
    projectId,
    modalType,
    action,
    details,
    timestamp: new Date().toISOString(),
  });
  try {
    const { data, error } = await supabase
      .from('modal_decision_log')
      .insert({
        project_id: projectId,
        modal_type: modalType,
        action: action,
        details: details || null,
      } as any)
      .select('id, created_at');

    if (error) {
      console.error(`%c[ModalLog] DB INSERT ERROR`, 'color: #ef4444; font-weight: bold', {
        projectId,
        modalType,
        action,
        error,
      });
      return;
    }

    const inserted = (data as any[])?.[0];
    console.log(`%c[ModalLog] ✅ DB INSERT SUCCESS`, 'color: #22c55e; font-weight: bold', {
      projectId,
      modalType,
      action,
      insertedId: inserted?.id,
      createdAt: inserted?.created_at,
    });
  } catch (error) {
    // Logging is best-effort — don't break the user flow if it fails
    console.error(`%c[ModalLog] ❌ EXCEPTION`, 'color: #ef4444; font-weight: bold', {
      projectId,
      modalType,
      action,
      error,
    });
  }
}
